import gql from 'graphql-tag';

export default gql`
query ($id: String!) {
  getChannel (id: $id) {
    __typename
    id
    name
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/GetQuery.js